import React from 'react';
import { Typography, LinearProgress } from '@material-ui/core';
import { Page } from 'components';
import { makeStyles } from '@material-ui/styles';

const Loading = props => {
  const classes = useStyles();

  return (
    <Page
      className={classes.error}
      title={props.title}
    >
      <div className={classes.loading}>
        <Typography
          component="h1"
          gutterBottom
          variant="h3"
        >
                    Loading...
        </Typography>
        <LinearProgress color="secondary" />
      </div>
    </Page>
  );
};

export default Loading;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  loading: {
    paddingTop: '25%',
    paddingLeft: '20%',
    paddingRight: '20%',
    flexGrow: 1,
    textAlign: 'center'
  }
}));
